module.exports=/[ \xA0\u1680\u2000-\u200A\u202F\u205F\u3000]/


//////////////////
// WEBPACK FOOTER
// ../~/uc.micro/categories/Z/regex.js
// module id = 410
// module chunks = 0